import axios from "axios";

const KEY = "aya_tickets_v1";
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const uid = () => { try { return localStorage.getItem("jsonfirst_civ_userid"); } catch { return null; } };

const readLocal = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};
const writeLocal = (list) => {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch { /* stockage plein */ }
};

export const getTickets = () => readLocal();

export const saveTicket = (t) => {
  const item = { id: `${Date.now()}-${Math.floor(Math.random() * 999)}`, createdAt: new Date().toISOString(), synced: false, ...t };
  writeLocal([item, ...readLocal()]);
  const userId = uid();
  if (userId) {
    axios.post(`${API}/v3/tickets`, { user_id: userId, ticket: item })
      .then(() => writeLocal(readLocal().map((x) => (x.id === item.id ? { ...x, synced: true } : x))))
      .catch(() => {});
  }
  return item;
};

// Enrichit un billet existant (ex : paiement confirmé + reçu fiscal) puis re-sync serveur.
export const updateTicketDetails = (ref, patch) => {
  const list = readLocal();
  const item = list.find((x) => x.ref === ref);
  if (!item) return null;
  item.details = { ...(item.details || {}), ...patch };
  writeLocal(list);
  const userId = uid();
  if (userId) axios.post(`${API}/v3/tickets`, { user_id: userId, ticket: item }).catch(() => {});
  return item;
};

// Sync bidirectionnelle : pousse les billets locaux non synchronisés, puis fusionne avec le serveur.
export const fetchAllTickets = async (userId) => {
  const local = readLocal();
  if (!userId) return local;
  const unsynced = local.filter((t) => t.synced === false);
  await Promise.all(unsynced.map((t) =>
    axios.post(`${API}/v3/tickets`, { user_id: userId, ticket: t })
      .then(() => { t.synced = true; }).catch(() => {})
  ));
  try {
    const r = await axios.get(`${API}/v3/tickets`, { params: { user_id: userId } });
    const server = (r.data?.tickets || []).map((t) => ({ ...t, synced: true }));
    const byRef = new Map(server.map((t) => [t.ref, t]));
    local.forEach((t) => { if (!byRef.has(t.ref)) byRef.set(t.ref, t); });
    const merged = [...byRef.values()].sort((a, b) => (b.createdAt || "").localeCompare(a.createdAt || ""));
    writeLocal(merged);
    return merged;
  } catch {
    writeLocal(local);
    return local;
  }
};
